import { TagVariant } from "./InfoTag"; // Adjust the import path as needed

interface InfoTag {
    label: string;
    variant: TagVariant;
}

export function resolveRSVPTags(invite: { rsvpDeadline?: string | null }): InfoTag[] {
    const tags: InfoTag[] = [];

    if (invite.rsvpDeadline) {
        const now = new Date();
        const deadline = new Date(invite.rsvpDeadline);
        const hoursLeft = (deadline.getTime() - now.getTime()) / (1000 * 60 * 60);
        if (hoursLeft <= 24 && hoursLeft >= 0) {
            tags.push({
                label: "RSVP Due Soon",
                variant: TagVariant.RSVP_DUE_SOON
            });
        }
    }

    return tags;
}